export const GET_LIST_PRODUCT = 'GET_LIST_PRODUCT'
export const DETAIL_PRODUCT = 'DETAIL_PRODUCT'
